import { CanActivateFn, Router } from '@angular/router'
import { inject } from '@angular/core'
import { PermissionService } from './permission.service'

export const unsupportedRoleGuard: CanActivateFn = (_route, state) => {
  const permissionsSvc = inject(PermissionService)
  const router = inject(Router)

  if (state.url.includes('/sin-permisos')) {
    return true
  }

  if (!permissionsSvc.hasSupportedRole()) {
    return router.parseUrl('/sin-permisos')
  }

  return true
}
